// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars */
import React, { useState, useEffect } from "react";
import { 
  Building2, Plus, MoreVertical, MapPin, 
  Edit, Ban, Trash2, CheckCircle, Loader2, 
  Phone, Mail, User, Hash, Key,
  Search, ChevronLeft, ChevronRight
} from "lucide-react";

import CompanyModal from "../../components/modals/CompanyModal";
import CompanyAccessModal from "../../components/modals/CompanyAccessModal"; 

import { collection, onSnapshot, query, orderBy, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../config/firebase";

const AdminCompanies = () => {
  // 🟢 Tipagem para blindar o TypeScript
  const [companies, setCompanies] = useState(/** @type {any[]} */ ([]));
  const [loading, setLoading] = useState(true);
  const [activeDropdown, setActiveDropdown] = useState(null);
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [companyToEdit, setCompanyToEdit] = useState(null);

  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);
  const [companyForAccess, setCompanyForAccess] = useState(null);
  
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  
  const brandColor = "#00a99d";

  useEffect(() => {
    const q = query(collection(db, "companies"), orderBy("createdAt", "desc"));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const companiesData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCompanies(companiesData);
      setLoading(false);
    }, (error) => {
      console.error("Erro ao buscar imobiliárias:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]);

  const handleToggleStatus = async (id, currentStatus) => {
    try {
      const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
      const companyRef = doc(db, "companies", id);
      await updateDoc(companyRef, { status: newStatus });
      setActiveDropdown(null);
    } catch (error) {
      console.error("Erro ao atualizar status:", error);
      alert("Erro ao atualizar o status da imobiliária.");
    }
  };

  const handleDeleteCompany = async (id, name) => {
    if (window.confirm(`Atenção PERIGO: Tem certeza que deseja remover permanentemente a imobiliária ${name} e todos os seus dados?`)) {
      try {
        const companyRef = doc(db, "companies", id);
        await deleteDoc(companyRef);
        setActiveDropdown(null);
      } catch (error) {
        console.error("Erro ao remover imobiliária:", error);
        alert("Erro ao remover a imobiliária do sistema.");
      }
    } else {
      setActiveDropdown(null);
    }
  };

  const handleEditClick = (company) => {
    setCompanyToEdit(company);
    setIsModalOpen(true);
    setActiveDropdown(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCompanyToEdit(null);
  };

  const toggleDropdown = (id) => {
    setActiveDropdown(activeDropdown === id ? null : id);
  };

  const filteredCompanies = companies.filter(company => 
    company.nome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    company.cnpj?.includes(searchTerm) ||
    company.codigo?.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCompanies.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);

  const nextPage = () => { if (currentPage < totalPages) setCurrentPage(prev => prev + 1); };
  const prevPage = () => { if (currentPage > 1) setCurrentPage(prev => prev - 1); };

  if (loading) {
    return (
      <div className="p-4 sm:p-6 lg:p-8 xl:p-10 w-full max-w-[1600px] mx-auto font-sans animate-pulse">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4 border-b border-light-border dark:border-dark-border pb-6">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-slate-200 dark:bg-slate-800 rounded-xl shrink-0"></div>
            <div className="space-y-2"><div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-64"></div><div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-96 hidden sm:block"></div></div>
          </div>
          <div className="h-10 bg-slate-200 dark:bg-slate-800 rounded-xl w-40"></div>
        </div>

        <div className="hidden lg:block bg-light-card dark:bg-dark-card rounded-xl shadow-sm border border-light-border dark:border-dark-border overflow-hidden">
          <div className="h-16 border-b border-light-border dark:border-dark-border bg-slate-50 dark:bg-dark-bg/50"></div>
          {Array(5).fill(0).map((_, i) => (
            <div key={i} className="flex items-center justify-between p-6 border-b border-light-border dark:border-dark-border">
              <div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-16"></div>
              {/* 🟢 Skeketon Loader usando as mesmas frações da tabela */}
              <div className="flex gap-4 w-1/3"><div className="w-10 h-10 bg-slate-200 dark:bg-slate-800 rounded-lg"></div><div className="space-y-2 flex-1"><div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-3/4"></div><div className="h-3 bg-slate-200 dark:bg-slate-800 rounded w-1/2"></div></div></div>
              <div className="space-y-2 w-1/4"><div className="h-4 bg-slate-200 dark:bg-slate-800 rounded w-full"></div><div className="h-3 bg-slate-200 dark:bg-slate-800 rounded w-2/3"></div></div>
              <div className="space-y-2 w-1/6"><div className="h-3 bg-slate-200 dark:bg-slate-800 rounded w-3/4"></div><div className="h-3 bg-slate-200 dark:bg-slate-800 rounded w-full"></div></div>
              <div className="h-6 bg-slate-200 dark:bg-slate-800 rounded-full w-16"></div>
              <div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-8"></div>
            </div>
          ))}
        </div>

        <div className="lg:hidden flex flex-col gap-4 mt-6">
          {Array(3).fill(0).map((_, i) => (
            <div key={i} className="bg-light-card dark:bg-dark-card rounded-2xl p-5 border border-light-border dark:border-dark-border h-48"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="p-4 sm:p-6 lg:p-8 xl:p-10 w-full max-w-[1600px] mx-auto font-sans animate-fade-in relative">
        
        {activeDropdown && (
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setActiveDropdown(null)}
          ></div>
        )}

        <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4 border-b border-light-border dark:border-dark-border pb-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-teal-50 dark:bg-teal-900/20 flex items-center justify-center shrink-0 border border-teal-100/50 dark:border-teal-800/30">
              <Building2 className="w-6 h-6 md:w-7 md:h-7" style={{ color: brandColor }} />
            </div>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-slate-800 dark:text-white">
                Imobiliárias Parceiras
              </h1>
              <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">
                Gestão dos inquilinos (Tenants) que utilizam o sistema da Real Benefícios.
              </p>
            </div>
          </div>
          
          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center justify-center px-6 py-3 sm:py-2.5 border border-transparent text-sm font-bold rounded-xl text-white transition-all duration-200 shadow-md hover:brightness-110 focus:outline-none shrink-0 w-full sm:w-auto mt-2 md:mt-0"
            style={{ backgroundColor: brandColor }}
          >
            <Plus className="w-4 h-4 mr-2" />
            Nova Imobiliária
          </button>
        </div>

        <div className="bg-light-card dark:bg-dark-card rounded-t-xl border border-light-border dark:border-dark-border border-b-0 p-4 sm:p-5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="relative w-full sm:max-w-md">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="w-4 h-4 text-slate-400" />
            </div>
            <input 
              type="text"
              placeholder="Buscar por nome, CNPJ ou código..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-9 pr-4 py-2.5 bg-light-bg dark:bg-dark-bg border border-light-border dark:border-dark-border rounded-xl text-sm focus:outline-none focus:border-[#00a99d] focus:ring-1 focus:ring-[#00a99d] transition-shadow text-light-text-primary dark:text-dark-text-primary"
            />
          </div>
        </div>

        <div className={`hidden lg:block bg-light-card dark:bg-dark-card rounded-b-xl shadow-sm border border-light-border dark:border-dark-border transition-all duration-300 ease-in-out ${activeDropdown ? 'pb-48' : ''} w-full overflow-hidden`}>
          <table className="w-full divide-y divide-light-border dark:divide-dark-border table-fixed">
            <thead className="bg-gray-50 dark:bg-dark-bg/50">
              <tr>
                {/* 🟢 LARGURAS CORRIGIDAS USANDO FRAÇÕES NATIVAS DO TAILWIND */}
                <th scope="col" className="w-1/12 px-6 py-4 text-left text-[11px] font-bold text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider">
                  Código
                </th>
                <th scope="col" className="w-1/3 px-6 py-4 text-left text-[11px] font-bold text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider">
                  Empresa / CNPJ
                </th>
                <th scope="col" className="w-1/4 px-6 py-4 text-left text-[11px] font-bold text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider">
                  Endereço
                </th>
                <th scope="col" className="w-1/6 px-6 py-4 text-left text-[11px] font-bold text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider">
                  Contato
                </th>
                <th scope="col" className="w-1/12 px-6 py-4 text-left text-[11px] font-bold text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider">
                  Status
                </th>
                <th scope="col" className="w-1/12 px-6 py-4 text-right text-[11px] font-bold text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-light-border dark:divide-dark-border bg-transparent">
              
              {currentItems.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-6 py-16 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <div className="w-16 h-16 bg-blue-50 dark:bg-blue-900/20 rounded-full flex items-center justify-center mb-4">
                        <Search className="w-8 h-8 text-blue-500 dark:text-blue-400" />
                      </div>
                      <h3 className="text-lg font-medium text-gray-900 dark:text-white">Nenhuma imobiliária encontrada</h3>
                      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 max-w-sm mx-auto">
                        Não localizamos registros que correspondam à sua pesquisa atual nesta página.
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                currentItems.map((company) => (
                  <tr key={company.id} className="hover:bg-gray-50 dark:hover:bg-dark-bg/40 transition-colors relative">
                    
                    <td className="px-6 py-4 align-top">
                      <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 font-mono mt-1">
                        <Hash className="w-3 h-3 mr-1 opacity-50" />
                        {company.codigo || "---"}
                      </div>
                    </td>

                    <td className="px-6 py-4 align-top">
                      <div className="flex items-start">
                        <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center text-indigo-700 dark:text-indigo-400 font-bold border border-indigo-200 dark:border-indigo-800">
                          <Building2 className="w-5 h-5" />
                        </div>
                        <div className="ml-4 min-w-0">
                          <div className="text-sm font-bold text-light-text-primary dark:text-dark-text-primary break-words">
                            {company.nome || "Empresa sem nome"}
                          </div>
                          <div className="text-xs text-light-text-secondary dark:text-dark-text-secondary mt-1 uppercase tracking-wider">
                            CNPJ: {company.cnpj || "Não informado"}
                          </div>
                          {company.creci && (
                             <div className="text-[10px] font-bold text-gray-400 dark:text-gray-500 mt-1 uppercase">
                              CRECI: {company.creci}
                             </div>
                          )}
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4 align-top">
                      <div className="text-sm text-light-text-primary dark:text-dark-text-primary flex items-start">
                        <MapPin className="w-4 h-4 mr-2 text-gray-400 shrink-0 mt-0.5" />
                        <div className="break-words min-w-0">
                          <span className="block font-medium">{company.endereco ? `${company.endereco}, ${company.numero}` : "Endereço não informado"}</span>
                          <span className="block text-xs text-gray-500 mt-1">{company.cidade ? `${company.cidade} - ${company.estado}` : ""}</span>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4 align-top">
                      <div className="space-y-1.5 min-w-0">
                        {company.contato && (
                          <div className="text-xs font-medium text-gray-700 dark:text-gray-300 flex items-center truncate" title={company.contato}>
                            <User className="w-3.5 h-3.5 mr-2 text-gray-400 shrink-0" /> {company.contato}
                          </div>
                        )}
                        <div className="text-xs text-gray-700 dark:text-gray-300 flex items-center">
                          <Phone className="w-3.5 h-3.5 mr-2 text-gray-400 shrink-0" /> {company.telefone || "---"}
                        </div>
                        <div className="text-xs text-gray-700 dark:text-gray-300 flex items-center truncate" title={company.email}>
                          <Mail className="w-3.5 h-3.5 mr-2 text-gray-400 shrink-0" /> {company.email || "---"}
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4 align-top">
                      <span className={`inline-flex items-center px-2.5 py-1 mt-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider border ${
                        company.status === 'active' 
                          ? 'bg-green-50 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-800' 
                          : 'bg-red-50 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-800'
                      }`}>
                        {company.status === 'active' ? 'Ativa' : 'Bloqueada'}
                      </span>
                    </td>
                    
                    <td className="px-6 py-4 text-right text-sm font-medium align-top">
                      <div className="relative flex justify-end text-left w-full h-full">
                        <button 
                          onClick={() => toggleDropdown(company.id)}
                          className={`text-light-text-secondary dark:text-dark-text-secondary hover:text-light-text-primary dark:hover:text-dark-text-primary transition-colors focus:outline-none p-1.5 rounded-md hover:bg-gray-100 dark:hover:bg-dark-border mt-0.5 ${activeDropdown === company.id ? 'relative z-30 bg-gray-100 dark:bg-dark-border' : ''}`}
                        >
                          <MoreVertical className="w-5 h-5" />
                        </button>

                        {activeDropdown === company.id && (
                          <div className="absolute right-0 top-10 mt-2 w-52 bg-white dark:bg-dark-card border border-light-border dark:border-dark-border rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none animate-fade-in z-40 py-1 overflow-hidden">
                            
                            <button
                              onClick={() => { 
                                setCompanyForAccess(company); 
                                setIsAccessModalOpen(true); 
                                setActiveDropdown(null); 
                              }}
                              className="w-full text-left px-4 py-2.5 text-sm text-blue-700 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 flex items-center transition-colors font-bold border-b border-gray-50 dark:border-dark-border"
                            >
                              <Key className="w-4 h-4 mr-2.5" />
                              Gerenciar Acessos
                            </button>

                            <button
                              onClick={() => handleEditClick(company)} 
                              className="w-full text-left px-4 py-2.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-dark-border flex items-center transition-colors"
                            >
                              <Edit className="w-4 h-4 mr-2.5 text-gray-400 dark:text-gray-500" />
                              Editar Empresa
                            </button>
                            
                            <button
                              onClick={() => handleToggleStatus(company.id, company.status)}
                              className="w-full text-left px-4 py-2.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-dark-border flex items-center transition-colors"
                            >
                              {company.status === 'active' ? (
                                <>
                                  <Ban className="w-4 h-4 mr-2.5 text-red-500" />
                                  Bloquear Acesso
                                </>
                              ) : (
                                <>
                                  <CheckCircle className="w-4 h-4 mr-2.5 text-green-500" />
                                  Desbloquear Acesso
                                </>
                              )}
                            </button>

                            <div className="border-t border-gray-50 dark:border-dark-border my-1"></div>
                            
                            <button
                              onClick={() => handleDeleteCompany(company.id, company.nome)}
                              className="w-full text-left px-4 py-2.5 text-sm font-bold text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 flex items-center transition-colors"
                            >
                              <Trash2 className="w-4 h-4 mr-2.5" />
                              Excluir Empresa
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="lg:hidden flex flex-col gap-4 mb-4">
          {currentItems.length === 0 ? (
            <div className="bg-light-card dark:bg-dark-card rounded-2xl p-8 text-center border border-light-border dark:border-dark-border shadow-sm flex flex-col items-center">
              <div className="w-16 h-16 bg-blue-50 dark:bg-blue-900/20 rounded-full flex items-center justify-center mb-4">
                <Search className="w-8 h-8 text-blue-500 dark:text-blue-400" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 dark:text-white">Nenhuma imobiliária</h3>
              <p className="mt-2 text-sm text-gray-500 dark:text-gray-400 max-w-sm mx-auto leading-relaxed">
                Nenhum registro corresponde à sua pesquisa.
              </p>
            </div>
          ) : (
            currentItems.map((company) => (
              <div key={`mobile-${company.id}`} className="bg-light-card dark:bg-dark-card rounded-b-2xl rounded-t-none lg:rounded-2xl p-5 border border-light-border dark:border-dark-border border-t-0 lg:border-t shadow-sm flex flex-col gap-4">
                
                <div className="flex justify-between items-center">
                  <span className="text-xs font-mono font-bold text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-800 px-2 py-1.5 rounded-lg border border-slate-200 dark:border-slate-700">
                    <Hash className="w-3 h-3 inline mr-1 opacity-70" />
                    {company.codigo || "S/N"}
                  </span>
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wider border ${ company.status === 'active' ? 'bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-400 dark:border-green-800' : 'bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-400 dark:border-red-800' }`}>
                    {company.status === 'active' ? 'Ativa' : 'Bloqueada'}
                  </span>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 h-12 w-12 rounded-xl bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center text-indigo-700 dark:text-indigo-400 font-bold border border-indigo-200 dark:border-indigo-800">
                    <Building2 className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col flex-1 pt-0.5 min-w-0">
                    <span className="text-base font-bold text-light-text-primary dark:text-dark-text-primary leading-tight truncate">
                      {company.nome || "Empresa sem nome"}
                    </span>
                    <span className="text-xs font-medium text-light-text-secondary dark:text-slate-400 mt-1 uppercase tracking-wider truncate">
                      CNPJ: {company.cnpj || "Não informado"}
                    </span>
                    {company.creci && (
                      <span className="text-[10px] font-bold text-brand-primary mt-1 truncate">
                        CRECI: {company.creci}
                      </span>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-3 bg-slate-50 dark:bg-slate-800/50 p-4 rounded-xl border border-slate-100 dark:border-slate-700/50 mt-1">
                  
                  {company.endereco && (
                    <div className="flex items-start gap-3 text-sm text-slate-600 dark:text-slate-300">
                      <MapPin className="w-4 h-4 text-brand-primary shrink-0 mt-0.5" />
                      <span className="leading-snug text-xs font-medium">
                        {company.endereco}, {company.numero} - {company.cidade}/{company.estado}
                      </span>
                    </div>
                  )}

                  {(company.contato || company.telefone || company.email) && (
                    <div className="pt-3 border-t border-slate-200 dark:border-slate-700 space-y-2">
                      {company.contato && (
                        <div className="flex items-center gap-3 text-xs text-slate-600 dark:text-slate-300">
                          <User className="w-4 h-4 text-slate-400 shrink-0" />
                          <span className="font-bold truncate">{company.contato}</span>
                        </div>
                      )}
                      {company.telefone && (
                        <div className="flex items-center gap-3 text-xs text-slate-600 dark:text-slate-300">
                          <Phone className="w-4 h-4 text-slate-400 shrink-0" />
                          <span>{company.telefone}</span>
                        </div>
                      )}
                      {company.email && (
                        <div className="flex items-center gap-3 text-xs text-slate-600 dark:text-slate-300 min-w-0">
                          <Mail className="w-4 h-4 text-slate-400 shrink-0" />
                          <span className="truncate">{company.email}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-2 mt-2 pt-4 border-t border-light-border dark:border-dark-border">
                  <button 
                    onClick={() => { setCompanyForAccess(company); setIsAccessModalOpen(true); }} 
                    className="flex items-center justify-center gap-2 py-2.5 bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400 rounded-xl text-xs font-bold hover:bg-blue-100 transition-colors border border-blue-200 dark:border-blue-800 shadow-sm"
                  >
                    <Key className="w-4 h-4"/> Acessos
                  </button>
                  
                  <button 
                    onClick={() => handleEditClick(company)} 
                    className="flex items-center justify-center gap-2 py-2.5 bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 rounded-xl text-xs font-bold hover:bg-slate-200 transition-colors border border-slate-200 dark:border-slate-700 shadow-sm"
                  >
                    <Edit className="w-4 h-4"/> Editar
                  </button>
                  
                  <button 
                    onClick={() => handleToggleStatus(company.id, company.status)} 
                    className={`flex items-center justify-center gap-2 py-2.5 rounded-xl text-xs font-bold transition-colors border shadow-sm ${company.status === 'active' ? 'bg-orange-50 text-orange-700 hover:bg-orange-100 border-orange-200 dark:bg-orange-900/20 dark:text-orange-400 dark:border-orange-800' : 'bg-green-50 text-green-700 hover:bg-green-100 border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800'}`}
                  >
                    {company.status === 'active' ? <><Ban className="w-4 h-4"/> Bloquear</> : <><CheckCircle className="w-4 h-4"/> Desbloquear</>}
                  </button>
                  
                  <button 
                    onClick={() => handleDeleteCompany(company.id, company.nome)} 
                    className="flex items-center justify-center gap-2 py-2.5 bg-red-50 text-red-700 hover:bg-red-100 dark:bg-red-900/20 dark:text-red-400 rounded-xl text-xs font-bold transition-colors border border-red-200 dark:border-red-800 shadow-sm"
                  >
                    <Trash2 className="w-4 h-4"/> Excluir
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {filteredCompanies.length > 0 && (
          <div className="p-4 border border-light-border dark:border-dark-border bg-light-card dark:bg-dark-card rounded-b-xl lg:rounded-xl mt-0 lg:mt-4 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-light-text-secondary dark:text-dark-text-secondary shadow-sm">
            <span className="font-medium text-center md:text-left">
              Mostrando <strong className="text-light-text-primary dark:text-dark-text-primary">{indexOfFirstItem + 1}</strong> a <strong className="text-light-text-primary dark:text-dark-text-primary">{Math.min(indexOfLastItem, filteredCompanies.length)}</strong> de <strong className="text-light-text-primary dark:text-dark-text-primary">{filteredCompanies.length}</strong> imobiliárias
            </span>
            
            <div className="flex flex-col sm:flex-row items-center gap-4 w-full md:w-auto">
              <div className="flex items-center gap-2 bg-light-bg dark:bg-dark-bg px-3 py-1.5 rounded-lg border border-light-border dark:border-dark-border shadow-sm w-full sm:w-auto justify-center">
                <span className="font-medium">Itens por página:</span>
                <select 
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  className="bg-transparent border-none font-bold text-brand-primary focus:ring-0 cursor-pointer text-sm outline-none"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>

              {totalPages > 1 && (
                <div className="flex items-center gap-2 justify-center w-full sm:w-auto">
                  <button 
                    onClick={prevPage}
                    disabled={currentPage === 1}
                    className="p-1.5 rounded-lg border border-light-border dark:border-dark-border bg-light-bg dark:bg-dark-bg hover:brightness-95 disabled:opacity-50 transition-colors shadow-sm text-light-text-secondary dark:text-dark-text-secondary"
                  >
                    <ChevronLeft className="w-5 h-5" />
                  </button>
                  <span className="text-sm font-bold text-light-text-primary dark:text-dark-text-primary px-3 py-1 bg-light-bg dark:bg-dark-bg border border-light-border dark:border-dark-border rounded-lg shadow-sm">
                    {currentPage} / {totalPages}
                  </span>
                  <button 
                    onClick={nextPage}
                    disabled={currentPage >= totalPages}
                    className="p-1.5 rounded-lg border border-light-border dark:border-dark-border bg-light-bg dark:bg-dark-bg hover:brightness-95 disabled:opacity-50 transition-colors shadow-sm text-light-text-secondary dark:text-dark-text-secondary"
                  >
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

      </div>

      {/* @ts-expect-error - Mismatch de tipagem do React Portal vs JSX Element */}
      <CompanyModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        companyToEdit={companyToEdit}
      />

      {/* @ts-expect-error - Mismatch de tipagem do React Portal vs JSX Element */}
      <CompanyAccessModal 
        isOpen={isAccessModalOpen}
        onClose={() => {
          setIsAccessModalOpen(false);
          setCompanyForAccess(null);
        }}
        company={companyForAccess}
      />
    </>
  );
};

export default AdminCompanies;